import React, { Component, useEffect, useState } from "react";
import Header from "./components/header/header";
import LandingPage from "./components/landing-page/LandingPage";
import AboutMe from "./components/about-me/AboutMe";
import Projects from "./components/projects/Projects";
import TechStack from "./components/techstack/TechStack";
import Certifications from "./components/certifications/Certifications";
import Fab from "@mui/material/Fab";
import UpIcon from "@mui/icons-material/KeyboardArrowUp";
import WorkXP from "./components/workxp/WorkXP";
import Research from "./components/projects/research/Research";
import Greenpath from "./components/projects/greenpath/Greenpath";
import ContactMe from "./components/contact-me/ContactMe";

const App = () => {
  const [scrollData, setScrollData] = useState("");
  const [visibleUpIcon, setVisibleUpIcon] = useState(false);

  window.addEventListener("wheel", (event) => {
    const delta = Math.sign(event.deltaY);
    if (delta == 1) {
      setVisibleUpIcon(true);
    }
  });

  const getScrollHandle = (data) => {
    setVisibleUpIcon(true);
    setScrollData(data);
    setTimeout(() => {
      setScrollData("");
    }, 500);
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
    setVisibleUpIcon(false);
  };

  return (
    <div>
      {visibleUpIcon ? (
        <div
          style={{
            position: "fixed",
            display: "flex",
            justifyContent: "end",
            flexDirection: "column",
            alignItems: "end",
            zIndex: "2",
            right: "5vh",
            bottom: "5vh",
          }}
        >
          <Fab color="primary" aria-label="add" onClick={scrollToTop}>
            <UpIcon />
          </Fab>
        </div>
      ) : (
        ""
      )}

      <Header scrollHandle={getScrollHandle} />
      <LandingPage sd={scrollData} />
      <br />
      <br />
      <AboutMe sd={scrollData} />
      <Projects sd={scrollData} />
      <Research />
      <Greenpath />
      <TechStack sd={scrollData} />
      <Certifications sd={scrollData} />
      <WorkXP sd={scrollData} />
      <ContactMe sd={scrollData} />
    </div>
  );
};

export default App;
